module.exports = __webpack_public_path__ + "static/media/invernessMusic.087fb1aa.mp3";